export const AdmissionCategories = [
    { value: "merit", text: "Merit" },
    { value: "management", text: "Management" },
    { value: "nri", text: "NRI" },
    { value: "sports", text: "Sports" },
    { value: "cultural", text: "Cultural" },
    { value: "disabled", text: "Disabled" },
    { value: "government", text: "Government" },
    { value: "economically_weaker_section", text: "Economically Weaker Section (EWS)" },
    { value: "supernumerary", text: "Supernumerary" },
    { value: "foreign_national", text: "Foreign National" },
    { value: "other", text: "Other" }
  ];
  